var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadIframe = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.69995 16.4666C2.69995 16.08 3.01335 15.7666 3.39995 15.7666L14.6 15.7666C14.9866 15.7666 15.3 16.08 15.3 16.4666C15.3 16.8532 14.9866 17.1666 14.6 17.1666L3.39995 17.1666C3.01335 17.1666 2.69995 16.8532 2.69995 16.4666Z",
    fill: "#1A1A24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50498 13.2283C8.77834 13.5017 9.22156 13.5017 9.49493 13.2283L12.7616 9.96162C13.035 9.68825 13.035 9.24504 12.7616 8.97167C12.4882 8.6983 12.045 8.6983 11.7716 8.97167L9.69995 11.0434V1.53331C9.69995 1.14671 9.38655 0.833313 8.99995 0.833313C8.61335 0.833313 8.29995 1.14671 8.29995 1.53331V11.0434L6.22826 8.97167C5.95489 8.6983 5.51168 8.6983 5.23831 8.97167C4.96494 9.24504 4.96494 9.68825 5.23831 9.96162L8.50498 13.2283Z",
    fill: "#1A1A24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadIframe);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/downloadIframe.c5d6fe8eca708166662fb290157d8731.svg";